export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_NA-zh-CN.fcd3e35f.xlsx";